/**
 * Error tracking (sentry.io or a self-hosted GlitchTip). Loaded only when
 * VITE_SENTRY_DSN is set, so the site doesn't carry the SDK otherwise.
 * No personal data: no IPs, no emails, no request bodies.
 */
const DSN = import.meta.env.VITE_SENTRY_DSN
let sentry = null

const ready = DSN
  ? import('@sentry/react').then((S) => {
      S.init({
        dsn: DSN,
        environment: import.meta.env.MODE,
        release: import.meta.env.VITE_RELEASE || undefined,
        sendDefaultPii: false,
        tracesSampleRate: 0,
      })
      sentry = S
      return S
    })
  : Promise.resolve(null)

/** React root error handlers call this: the component stack goes along. */
export function captureError(error, info, kind) {
  if (!DSN) return
  ready.then(() =>
    sentry?.captureException(error, {
      tags: { react: kind },
      contexts: info?.componentStack ? { react: { componentStack: info.componentStack } } : undefined,
    }),
  )
}
